export default __webpack_public_path__ + "static/media/uberEats.0fcb20da.png";